// extracted by mini-css-extract-plugin
export default {"container":"HtmlCss_container__x5VfD","cards":"HtmlCss_cards__-A2Se","card":"HtmlCss_card__dImR+","img":"HtmlCss_img__eRR0x","text":"HtmlCss_text__jdMml","src":"HtmlCss_src__VQKmh"};